import React, { FC } from "react";
import { Divider, DividerProps } from "@mui/material"

const DividerWrapper: FC<DividerProps> = ({...props}) => <Divider {...props}/>

export default DividerWrapper;